module.exports = __webpack_public_path__ + "static/media/aristoteles_desc4.cc37a0f3.png";